import { BOTTOM_MENU_HEIGHT } from '#/components/common/app-bar/BottomMenu';

const CLOSED_OVERLAY_HEIGHT = 32;
export const BOTTOM_OFFSET = CLOSED_OVERLAY_HEIGHT + BOTTOM_MENU_HEIGHT;
export const getClosedY = () => window.innerHeight - BOTTOM_OFFSET;

export const getOpenY = () => 80;
